const psApexFromEnv: unknown = import.meta.env.VITE_PS_APEX
const normalizedPsApex = typeof psApexFromEnv === "string" ? psApexFromEnv.trim() : ""
const PS_APEX = normalizedPsApex || "nextshutter.com"
const apex = (path = "") => `https://${PS_APEX}${path}`
const subdomain = (name: string, path = "") => `https://${name}.${PS_APEX}${path}`
const ALLOWED_PIXIESET_APEXES = new Set(
	[PS_APEX, "pixieset.com", "nextshutter.com"].map((domain) => domain.toLowerCase()),
)

export const normalizePixiesetLogosUrl = (url?: string): string | undefined => {
	if (!url) {
		return url
	}

	try {
		const parsed = new URL(url)
		const hostname = parsed.hostname.toLowerCase()
		const isPixiesetHost = Array.from(ALLOWED_PIXIESET_APEXES).some(
			(apexDomain) => hostname === apexDomain || hostname.endsWith(`.${apexDomain}`),
		)

		if (!hostname.startsWith("logos.") || !isPixiesetHost) {
			return url
		}
		parsed.hostname = hostname.replace(/^logos\./, "logos-pe.")
		return parsed.toString()
	} catch {
		return url
	}
}

export const pixiesetSubdomains = {
	auth: subdomain("auth"),
	editor: subdomain("editor"),
	galleries: subdomain("galleries"),
	gallery: subdomain("gallery"),
	mobileapp: subdomain("mobileapp"),
	studio: subdomain("studio"),
	website: subdomain("website"),
} as const

export const pixiesetAPIBaseURIs = {
	galleries: subdomain("galleries", "/api/"),
	images: subdomain("photos-pe"),
	services: subdomain("services"),
} as const

export const pixiesetAssetBaseURIs = {
	filesPe: subdomain("files-pe"),
	imagesPe: subdomain("images-pe"),
} as const

export const pixiesetURLs = {
	root: {
		photoEditorDownload: apex("/photo-editor-download/"),
	},
	accounts: {
		dashboard: subdomain("accounts", "/dashboard/"),
		registration: subdomain("accounts", "/registration/"),
	},
	gallery: {
		account: subdomain("gallery", "/account/"),
		accountBilling: subdomain("gallery", "/account/billing/"),
		accountUpgrade: (cycle: "year" | "month", returnUrl: string) =>
			subdomain(
				"gallery",
				`/account/upgrade/?product=photo-editor&plan=pro&cycle=${cycle}&returnUrl=${encodeURIComponent(returnUrl)}`,
			),
		store: subdomain("gallery", "/store/"),
	},
	galleries: {
		collections: subdomain("galleries", "/collections"),
	},
	help: {
		hcEnUs: subdomain("help", "/hc/en-us"),
		hcEnUsSearch: (query: string) =>
			subdomain("help", `/hc/en-us?search?query=${encodeURIComponent(query)}`),
	},
} as const
